<template>
  <footer class="flex flex-column mt-auto mr-8 mb-5 lg:w-11 sm:w-12">
    <Divider />
    <div class="flex flex-row flex-wrap justify-content-between">
      <div>
        <slot name="left" />
      </div>
      <div>
        <slot />
      </div>
    </div>
  </footer>
</template>
<script lang="ts" setup>
  import { onMounted, ref } from 'vue'
</script>
